import { render, staticRenderFns } from "./SimpleCollapse.vue?vue&type=template&id=252e3000"
import script from "./SimpleCollapse.vue?vue&type=script&lang=js"
export * from "./SimpleCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports